import { render, staticRenderFns } from "./LogisticsNetworkPage.vue?vue&type=template&id=2b327ddb&"
import script from "./LogisticsNetworkPage.vue?vue&type=script&lang=ts&"
export * from "./LogisticsNetworkPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports